import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fa1504f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "huddle-metric" }

import { palette } from '@/utils/palette'
import Typography from '@/components/Rain/Typography/Typography.vue'

interface Props {
    topLabel: string
    metricValue: string
    bottomLabel?: string | undefined
    valueColor?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddlesMetric',
  props: {
    topLabel: {},
    metricValue: {},
    bottomLabel: { default: undefined },
    valueColor: { default: palette.pGray900 }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Typography, {
      variant: "caption",
      class: "label"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.topLabel), 1)
      ], undefined, true),
      _: 1
    }),
    _createElementVNode("div", {
      class: "metric-value",
      style: _normalizeStyle({ color: _ctx.valueColor })
    }, _toDisplayString(_ctx.metricValue), 5),
    (_ctx.bottomLabel)
      ? (_openBlock(), _createBlock(Typography, {
          key: 0,
          variant: "caption",
          class: "label"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.bottomLabel), 1)
          ], undefined, true),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})